"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Balance = exports.BALANCE_TYPES = exports.BalanceTypes = void 0;
class BalanceTypes {
    constructor() {
        this.ACCOUNT = 'ACCOUNT';
        this.SECURITY = 'SECURITY';
    }
}
exports.BalanceTypes = BalanceTypes;
exports.BALANCE_TYPES = new BalanceTypes();
class Balance {
}
exports.Balance = Balance;
//# sourceMappingURL=balance.js.map